<template>
    <div class="up-box" :class="mobileDevice?'mobileDevice':''">
        <!-- <div class="title-box">
            <div class="m-title">Upload a PDF</div>
            <div class="s-title">Import a PDF file to use the sildesOrator</div>
        </div> -->
        <div class="up-content">
            <div class="item" v-if="!isUpload">
                <img class="up-icon" src="@/assets/upload.png" alt="" />
                <div class="tip">Upload a file or drag and drop here</div>
                <div class="tip1">pdf，up to 20MB</div>
                <input
                    class="file-select"
                    :type="!isUpload ? 'file' : 'txt'"
                    @change="handleChange"
                    title=""
                    accept=".pdf" />
            </div>
            <div class="item1" v-else>
                <img src="@/assets/loading.png" alt="" class="loading" />
                <div class="tips">
                    Your document is being uploaded. Please wait a moment.
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { Message } from "view-ui-plus";
import { detUUID } from "@/utils/utils";
import { uploadPDFURL } from "@/api";
import { uploadFileToGCS } from "@/utils/gcsUpload";
import { PDFload } from "@/utils/pdfload";
const store = useStore();
const isUpload = computed(() => store.state.file.isUpload);

import { useMixinMobileDevice } from "@/mixins/mobileDevice";
const { mobileDevice, Orientation } = useMixinMobileDevice();

// 处理文件选择
const handleChange = (e) => {
    store.dispatch("file/isUpload", true);
    const [file] = e.target.files;
    console.log(file);
    console.log(file.name);
    const uuid = detUUID();
    let pdfUrl = `${uuid}/doc/${uuid}_${file.name}`;
    let pdfName = file.name.substring(0, file.name.lastIndexOf("."));
    console.log(pdfUrl);


    if (!["application/pdf"].includes(file.type)) {
        Message.warning({
            background: true,
            content: "Please upload PDF file",
            duration: 5,
        });
        store.dispatch("file/isUpload", false);
        return;
    }

    if(file.size >= 1024*1024 * 20) {
        console.log('超20M')
        Message.warning({
            background: true,
            content: "File size exceeds 20M",
            duration: 5,
        });
        store.dispatch("file/isUpload", false);
        return false
    }
    uploadFileToGCS(file, pdfUrl).then((res) => {
        console.log("上传成功1");
        var reader = new FileReader();
        reader.readAsDataURL(file); //将文件读取为 DataURL
        reader.onload = function () {
            //文件读取成功完成时触发
            // console.log(reader.result)
            PDFload(reader.result, uuid, (pre) => {
                console.log(pre);
            })
                .then((e) => {
                    console.log(e);
                    e.sort((a, b) => {
                        let numA = parseInt(a.match(/_(\d+).jpeg$/)[1], 10);
                        let numB = parseInt(b.match(/_(\d+).jpeg$/)[1], 10);
                        return numA - numB;
                    });

                    console.log(e);
                    uploadPDFURL({
                        pdfUrl,
                        pdfName,
                        pdfPageUrl: e,
                    }).then((r) => {
                        console.log(r);
                        if (r.code == 200) {
                            store.dispatch("file/setFileID", r.data);
                            store.dispatch("app/setUpStep", 1);
                            store.dispatch("file/isUpload", false);
                        }
                    });
                })
                .catch(() => {
                    console.log("上传失败");
                });
        };
    });
};
</script>

<style lang="less" scoped>
.up-box {
    height: 450px;
    .close {
        position: absolute;
        top: -30px;
        right: 0px;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px 4px 4px 4px;
        cursor: pointer;

        &:hover {
            background: rgba(239, 239, 239, 1);
        }

        img {
            width: 16px;
            height: 16px;
        }
    }

    .title-box {
        display: flex;
        align-items: center;
        .m-title {
            font-size: 20px;
            font-weight: 500;
            color: #31302eff;
            margin-right: 10px;
        }
        .s-title {
            font-size: 12px;
            color: #31302e99;
        }
    }

    .up-content {
        height:240px;
        width: 100%;
        border: 1px dashed #4945ffff;
        border-radius: 8px;
        margin-top: 20px;
        position: relative;
        overflow: hidden;
        .item {
            height: 240px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &:hover {
                background: #f4f4ffff;
            }
            .up-icon {
                width: 64px;
                height: 64px;
                margin-bottom: 40px;
            }
            .file-select {
                width: 100%;
                height: 100%;
                opacity: 0;
                cursor: pointer;
                position: absolute;
                left: 0;
                top: 0;
            }

            .tip {
                font-size: 16px;
                color: #31302eff;
            }

            .tip1 {
                font-size: 14px;
                color: #31302e99;
                text-decoration: dashed;
                margin-top: 16px;
                text-decoration: underline;
            }
        }
        .item1 {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 0 30px;
            .tips {
                font-size: 16px;
                color: #4945ffff;
                font-weight: 500;
                text-align: center;
            }

            .loading {
                width:66px;
                height:66px;
                margin-bottom: 20px;
                animation: load 2s linear infinite;
            }

            @keyframes load {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        }
    }

    &.mobileDevice {
        height: 280px;
        .title-box {
            flex-direction: column;
        }
        .up-content {
            height: 240px;
        }
    }
}
</style>
